import Record from "slotworks/model/gameplay/records/record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import Result from "slotworks/model/gameplay/records/results/result";

export function freespinWinResultDisplay(record: Record, result: Result) {
    const container = document.createElement("div");

    container.innerHTML = "Freespins won: " + (result as FreespinWinResult).freespinsWon;

    return container;
}
